import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bulkCreateFulfillmentMethodResult = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _bulkCreateFulfillmentMethodsRequest = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _bulkCreateFulfillmentMethodsResponse = {
    results: '_bulkCreateFulfillmentMethodResult',
};
var _bulkUpdateFulfillmentMethodTagsByFilterRequest = {};
var _bulkUpdateFulfillmentMethodTagsByFilterResponse = {};
var _bulkUpdateFulfillmentMethodTagsRequest = {};
var _bulkUpdateFulfillmentMethodTagsResponse = {};
var _createFulfillmentMethodRequest = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _createFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _customArea = { geocodes: '_addressLocation' };
var _deleteFulfillmentMethodRequest = {};
var _deleteFulfillmentMethodResponse = {};
var _deliveryArea = {
    radiusOptions: '_radius',
    customOptions: '_customArea',
};
var _deliveryInfo = { deliveryArea: '_deliveryArea' };
var _fulfillmentMethod = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    pickupOptions: '_pickupInfo',
    deliveryOptions: '_deliveryInfo',
};
var _getAccumulatedFulfillmentMethodsAvailabilityRequest = {};
var _getAccumulatedFulfillmentMethodsAvailabilityResponse = {};
var _getAggregatedMethodAvailabilityRequest = {};
var _getAggregatedMethodAvailabilityResponse = {};
var _getCombinedMethodAvailabilityRequest = {};
var _getCombinedMethodAvailabilityResponse = {};
var _getFulfillmentMethodRequest = {};
var _getFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
var _listActiveFulfillmentMethodsRequest = {};
var _listActiveFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _listAvailableFulfillmentMethodsForAddressRequest = {
    address: '_address',
};
var _listAvailableFulfillmentMethodsForAddressResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _listFulfillmentMethodsRequest = { address: '_address' };
var _listFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _pickupInfo = { address: '_address' };
var _queryFulfillmentMethodsRequest = {
    projectionMask: 'google.protobuf.FieldMask',
};
var _queryFulfillmentMethodsResponse = {
    fulfillmentMethods: '_fulfillmentMethod',
};
var _radius = { centerPointAddress: '_address' };
var _updateFulfillmentMethodRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    fulfillmentMethod: '_fulfillmentMethod',
};
var _updateFulfillmentMethodResponse = {
    fulfillmentMethod: '_fulfillmentMethod',
};
function resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/fulfillment-methods',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/fulfillment-methods/v1',
                destPath: '/v1',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/fulfillment-methods',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new fulfillment method.
 *
 * >**Note:** `fulfillmentMethod.availability.time_zone` uses the time zone specified in the [`language and regions`](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fsettings/language-and-region) settings in the dashboard, regardless of the value provided.
 */
export function createFulfillmentMethod(payload) {
    var _a = serializer(_createFulfillmentMethodRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFulfillmentMethodResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __createFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.CreateFulfillmentMethod',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFulfillmentMethod.fromReq = fromReq;
    __createFulfillmentMethod.__isAmbassador = true;
    return __createFulfillmentMethod;
}
/** Create multiple fulfillment methods at once. */
export function bulkCreateFulfillmentMethods(payload) {
    var _a = serializer(_bulkCreateFulfillmentMethodsRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateFulfillmentMethodsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bulkCreateFulfillmentMethodResult: _bulkCreateFulfillmentMethodResult,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __bulkCreateFulfillmentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.BulkCreateFulfillmentMethods',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/bulk/fulfillment-methods/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateFulfillmentMethods.fromReq = fromReq;
    __bulkCreateFulfillmentMethods.__isAmbassador = true;
    return __bulkCreateFulfillmentMethods;
}
/** Retrieves a fulfillment method. */
export function getFulfillmentMethod(payload) {
    var _a = serializer(_getFulfillmentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFulfillmentMethodResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __getFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'GET',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetFulfillmentMethod',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/{fulfillmentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFulfillmentMethod.fromReq = fromReq;
    __getFulfillmentMethod.__isAmbassador = true;
    return __getFulfillmentMethod;
}
/**
 * Updates a fulfillment method.
 *
 * Each time the fulfillment method is updated, its revision increments by 1. The existing revision must be included when updating the fulfillment method. This ensures you're working with the latest fulfillment method information, and it prevents unintended overwrites.
 */
export function updateFulfillmentMethod(payload) {
    var _a = serializer(_updateFulfillmentMethodRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFulfillmentMethodResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __updateFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.UpdateFulfillmentMethod',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/{fulfillmentMethod.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFulfillmentMethod.fromReq = fromReq;
    __updateFulfillmentMethod.__isAmbassador = true;
    return __updateFulfillmentMethod;
}
/** Deletes a fulfillment method. */
export function deleteFulfillmentMethod(payload) {
    var _a = serializer(_deleteFulfillmentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteFulfillmentMethodResponse, {}).fromJSON;
    function __deleteFulfillmentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.DeleteFulfillmentMethod',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/{fulfillmentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteFulfillmentMethod.fromReq = fromReq;
    __deleteFulfillmentMethod.__isAmbassador = true;
    return __deleteFulfillmentMethod;
}
/**
 * Retrieves a list of fulfillment methods given the provided paging, filtering, and sorting. Up to 100 fulfillment methods can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/fulfillment-methods/sorting-and-filtering) article.
 * To learn how to query reservations, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryFulfillmentMethods(payload) {
    var _a = serializer(_queryFulfillmentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryFulfillmentMethodsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __queryFulfillmentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.QueryFulfillmentMethods',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryFulfillmentMethods.fromReq = fromReq;
    __queryFulfillmentMethods.__isAmbassador = true;
    return __queryFulfillmentMethods;
}
/** Retrieves a list of up to 100 fulfillment methods. */
export function listFulfillmentMethods(payload) {
    var _a = serializer(_listFulfillmentMethodsRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFulfillmentMethodsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __listFulfillmentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'GET',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.ListFulfillmentMethods',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFulfillmentMethods.fromReq = fromReq;
    __listFulfillmentMethods.__isAmbassador = true;
    return __listFulfillmentMethods;
}
/**
 * Retrieves a list of up to 100 fulfillment methods available for a given address.
 *
 * The response will only include:
 * - Non-delivery fulfillment methods.
 * - Delivery fulfillment methods that are available to the given address according to their delivery areas.
 */
export function listAvailableFulfillmentMethodsForAddress(payload) {
    var _a = serializer(_listAvailableFulfillmentMethodsForAddressRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailableFulfillmentMethodsForAddressResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __listAvailableFulfillmentMethodsForAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.ListAvailableFulfillmentMethodsForAddress',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/available-for-address',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailableFulfillmentMethodsForAddress.fromReq = fromReq;
    __listAvailableFulfillmentMethodsForAddress.__isAmbassador = true;
    return __listAvailableFulfillmentMethodsForAddress;
}
/**
 * Retrieves a list of up to 100 enabled fulfillment methods.
 *
 * The response will only include:
 * - External provider deliveries that are enabled and are returned as active by the provider.
 * - Enabled fulfillment methods that are not external provider deliveries.
 */
export function listActiveFulfillmentMethods(payload) {
    var _a = serializer(_listActiveFulfillmentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listActiveFulfillmentMethodsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _customArea: _customArea,
        _deliveryArea: _deliveryArea,
        _deliveryInfo: _deliveryInfo,
        _fulfillmentMethod: _fulfillmentMethod,
        _pickupInfo: _pickupInfo,
        _radius: _radius,
    }).fromJSON;
    function __listActiveFulfillmentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.ListActiveFulfillmentMethods',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/active',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listActiveFulfillmentMethods.fromReq = fromReq;
    __listActiveFulfillmentMethods.__isAmbassador = true;
    return __listActiveFulfillmentMethods;
}
/**
 * Retrieves the accumulated availability of all fulfillment methods.
 * @deprecated It has been replaced with wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetAggregatedMethodAvailability(), and will be removed on 2024-09-29.
 */
export function getAccumulatedFulfillmentMethodsAvailability(payload) {
    var _a = serializer(_getAccumulatedFulfillmentMethodsAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccumulatedFulfillmentMethodsAvailabilityResponse, {}).fromJSON;
    function __getAccumulatedFulfillmentMethodsAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'GET',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetAccumulatedFulfillmentMethodsAvailability',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/accumulated-availability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccumulatedFulfillmentMethodsAvailability.fromReq = fromReq;
    __getAccumulatedFulfillmentMethodsAvailability.__isAmbassador = true;
    return __getAccumulatedFulfillmentMethodsAvailability;
}
/**
 * Retrieves the combined availability of a list of fulfillment methods.
 *
 * The combined availability is a list of times during which one or more of the given fulfillment methods is available, and the types of those fulfillment methods.
 * @deprecated It has been replaced with wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetAggregatedMethodAvailability(), and will be removed on 2025-02-10.
 */
export function getCombinedMethodAvailability(payload) {
    var _a = serializer(_getCombinedMethodAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCombinedMethodAvailabilityResponse, {}).fromJSON;
    function __getCombinedMethodAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'GET',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetCombinedMethodAvailability',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/combined-availability',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCombinedMethodAvailability.fromReq = fromReq;
    __getCombinedMethodAvailability.__isAmbassador = true;
    return __getCombinedMethodAvailability;
}
/**
 * Retrieves the aggregated availability of a list of fulfillment methods.
 *
 * The aggregated availability is a list of times during which one or more of the given fulfillment methods is available, and the types of those fulfillment methods.
 */
export function getAggregatedMethodAvailability(payload) {
    var _a = serializer(_getAggregatedMethodAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAggregatedMethodAvailabilityResponse, {}).fromJSON;
    function __getAggregatedMethodAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.GetAggregatedMethodAvailability',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/fulfillment-methods/aggregated-availability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAggregatedMethodAvailability.fromReq = fromReq;
    __getAggregatedMethodAvailability.__isAmbassador = true;
    return __getAggregatedMethodAvailability;
}
/**
 * Synchronously update tags on multiple fulfillment methods.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateFulfillmentMethodTags(payload) {
    var _a = serializer(_bulkUpdateFulfillmentMethodTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFulfillmentMethodTagsResponse, {}).fromJSON;
    function __bulkUpdateFulfillmentMethodTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.BulkUpdateFulfillmentMethodTags',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/bulk/fulfillment-methods/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFulfillmentMethodTags.fromReq = fromReq;
    __bulkUpdateFulfillmentMethodTags.__isAmbassador = true;
    return __bulkUpdateFulfillmentMethodTags;
}
/**
 * Asynchronously update tags on multiple fulfillment methods according to the specified filter.
 * If a filter isn't specified, this method updates all fulfillment methods.
 * If you specify a tag in both `assignTags` and `unassignTags`, it is assigned.
 */
export function bulkUpdateFulfillmentMethodTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateFulfillmentMethodTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateFulfillmentMethodTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateFulfillmentMethodTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.v1.fulfillment_method',
            method: 'POST',
            methodFqn: 'wix.restaurants.fulfillment.v1.FulfillmentMethodsService.BulkUpdateFulfillmentMethodTagsByFilter',
            url: resolveWixRestaurantsFulfillmentV1FulfillmentMethodsServiceUrl({
                protoPath: '/v1/bulk/fulfillment-methods/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateFulfillmentMethodTagsByFilter.fromReq = fromReq;
    __bulkUpdateFulfillmentMethodTagsByFilter.__isAmbassador = true;
    return __bulkUpdateFulfillmentMethodTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map